import Vue from 'vue'
import Vuex from 'vuex'

// import moment from 'moment'

import projectService from '@/services/project-service.js'
import accessURLService from '@/services/access-url-service.js'
import subscriptionService from '@/services/subscription-service.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    projects: [],

    roomAccessURLs: {
      'livingroom-1': 'https://storage.googleapis.com/simply-studio-pub-01/stock/livingroom-1.jpg', 
      'livingroom-2': 'https://storage.googleapis.com/simply-studio-pub-01/stock/livingroom-2.jpg', 
      'hallway': 'https://storage.googleapis.com/simply-studio-pub-01/stock/hallway.jpg', 
      'livingroom-3': 'https://storage.googleapis.com/simply-studio-pub-01/stock/livingroom-3.jpg',
      'bedroom': 'https://storage.googleapis.com/simply-studio-pub-01/stock/bedroom.jpg',
      'kitchen': 'https://storage.googleapis.com/simply-studio-pub-01/stock/kitchen.jpg'
    },
    demoPhotoAccessURLs: {
      'demo-01': 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-01.jpeg',
      'demo-02': 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-02.jpeg',
      'demo-03': 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-03.jpeg',
      'demo-04': 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-04.jpeg',
      'demo-05': 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-05.jpeg',
    },

    loadingProjects: false,
    secret: null,

    user: {},
    subscription: {},
    expiresAt: null,

    percentBackgroundWidthPerUnit: 0.007,
    backgroundImage: {x: 0, y: 0, width: 0, height: 0},
  },
  mutations: {
    mutate(state, { prop, value }) {
      state[prop] = value
    },
    addToProject(state, { project, key, value }) {
      let p = state.projects.find(p => p.name == project)
      if(p)
        Vue.set(p, key, value) // works due to obj reference
    }
  },
  actions: {
    async getSubscription({ commit }) {
      let subscription = await subscriptionService.getSubscription()
      commit('mutate', { prop: 'subscription', value: subscription })
      commit('mutate', { prop: 'expiresAt', value: subscription.validUntil })
    },
    async getProject({commit, dispatch, state}, projectName) {
      let project = await projectService.getProject(projectName)
      let others = state.projects.filter(p => p.name != projectName)
      commit('mutate', { prop: 'projects', value: [...others, project] })
      dispatch('getAccessURLs', project.name)
      dispatch('getCustomRoomsAccessURLs', project.name)
    },
    async getProjects({ commit, dispatch, state }) {
      state.loadingProjects = true
      let projects = await projectService.getAllProjects()
      projects.sort((a, b) => new Date(a.created) - new Date(b.created)).reverse()
      commit('mutate', { prop: 'projects', value: projects })
      projects.forEach(p => {
        dispatch('getAccessURLs', p.name)
        dispatch('getCustomRoomsAccessURLs', p.name)
      }) // maybe not for all projects?
      state.loadingProjects = false
    },
    getAccessURLs({ commit, state }, project) {
      accessURLService.getGalleryAccessURLs(state.user.email, project, '')
        .then(urls => urls.sort((a, b) => a.name > b.name ? 1 : -1))
        .then(urls => commit('addToProject', { project: project, key: 'accessURLs', value: urls }))
    },
    getCustomRoomsAccessURLs({ state }, project){
      accessURLService.getCustomRoomsAccessURLs(state.user.email, project, '')
        .then(urls => urls.forEach(u => state.roomAccessURLs[u.name] = u.url))
    }
  },
  getters: {
    backgroundImage: state => state.backgroundImage,
    pixelPerUnit: state => state.percentBackgroundWidthPerUnit * state.backgroundImage.width,
    percentBackgroundWidthPerUnit: state => state.percentBackgroundWidthPerUnit,
    loadingProjects: state => state.loadingProjects,
    projects: state => state.projects,
    secret: state => state.secret,
    user: state => state.user,
    subscription: state => state.subscription,
    isTrial: state => state.subscription != {} && state.subscription.type == 'TRIAL',
    // expiresAt: state => state.subscription != {} ? moment(state.subscription.validUntil).unix() : null,
    expiresAt: state => state.expiresAt,
    isAuthenticated: state => state.user && Object.keys(state.user).length > 0,
    accessURL: state => filename => {
      let cache = state.projects.reduce((c, p) => {
        if(p.accessURLs)
          p.accessURLs.forEach(e => c[e.name] = e.url)
        return c
      }, {})
      let accessURL = cache[filename]
      if(!accessURL) {
        accessURL = state.demoPhotoAccessURLs[filename]
      }
      return accessURL || {}
    },
    roomAccessURL: state => roomName => state.roomAccessURLs[roomName]
  }
})
